import { Icon } from '@blueprintjs/core';
import DetailTable from 'Components/Generic/DetailPanel/DetailTable';
import OrgNameWithDrawerButton from 'Components/SiteDrawerContainer/OrgNameWithDrawerButton';
import UserNameWithDrawerButton from 'Components/SiteDrawerContainer/UserNameWithDrawerButton';
import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { getTagValue } from 'Util/tagUtil';
import styles from './RequestInformationPanel.module.css';

const RequestInformationTable = ({
  request = {},
  excludeIsRadioactive = false,
  showRequestId = false,
}) => {
  let data = [
    ...(showRequestId
      ? [
          {
            label: 'Request ID',
            value: (
              <Link to={`${SITE_PAGES.ORDER_DETAIL.to}/${request.id}`}>
                {request.id}
              </Link>
            ),
          },
        ]
      : []),
    {
      label: 'Core Facility',
      value: (
        <OrgNameWithDrawerButton
          orgId={request.parent_organization_id}
          wrapText
        />
      ),
    },
    {
      label: 'Requester',
      value: <UserNameWithDrawerButton userId={request.requesting_user_id} />,
    },
    {
      label: 'Processor',
      value: <UserNameWithDrawerButton userId={request.processing_user_id} />,
    },
    {
      label: 'Description',
      value: (
        <>
          {request?.notes && (
            <div
              style={{
                whiteSpace: 'pre-line',
              }}>
              {request.notes}
            </div>
          )}
          {!request?.notes && (
            <span className={styles.no_notes_label}>No comment</span>
          )}
        </>
      ),
    },
    ...(excludeIsRadioactive
      ? []
      : [
          {
            label: (
              <span style={{ color: 'var(--site-warning-color)' }}>
                Radioactive
              </span>
            ),
            value: (
              <Icon
                size='20'
                icon={getTagValue(request, 'is_radioactive') ? 'tick' : 'blank'}
              />
            ),
          },
        ]),
  ];

  return <DetailTable data={data} />;
};

RequestInformationTable.propTypes = {
  request: PropTypes.object,
  excludeIsRadioactive: PropTypes.bool,
  showRequestId: PropTypes.bool,
};

export default RequestInformationTable;
